import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import logo from './assets/4-kongres-nexus-knot.png';
import backMenu from './assets/backmenu.png';
import Rev from './assets/revicontag.png';
import Jafis from './assets/jafis.png';
import homeIcon from './assets/home.png';
import profileIcon from './assets/profil.png';
import faqIcon from './assets/FAQ.png';
import guideIcon from './assets/uputstva.png';
import quizIcon from './assets/upitnik.png';
import logoutIcon from './assets/logout.png';
import nexusLogo from './assets/nexus logo.png'


function Sidebar({ isOpen, closeSidebar }) {
  return (
    <>
     <div
  className={`sidebar ${isOpen ? 'open' : ''}`}
  style={{ 
    backgroundImage: `url(${backMenu})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  {/* gornji dio */}
  <div className="sidebar-content">
    <div className="logo-section logos-row">
      <img src={Rev} alt="Revicon Logo" className="rev-logo" />
      <img src={Jafis} alt="Jafis Logo" className="jafis-logo" />
    </div>

    <nav className="menu-section" onClick={closeSidebar}>
      <Link to="/welcome" className="menu-item"><img src={homeIcon} alt="" className="menu-icon" />Početna</Link>
      <Link to="/profile" className="menu-item"><img src={profileIcon} alt="" className="menu-icon" />Profil</Link>
      <Link to="/faq" className="menu-item"><img src={faqIcon} alt="" className="menu-icon" />FAQ</Link>
      <Link to="/uputstva" className="menu-item"><img src={guideIcon} alt="" className="menu-icon" />Uputstva</Link>
      <Link to="/questionnaire/1" className="menu-item"><img src={quizIcon} alt="" className="menu-icon" />Pristupi upitniku</Link>
      <Link to="/" className="menu-item"><img src={logoutIcon} alt="" className="menu-icon" />Logout</Link>
    </nav>
  </div>

  {/* footer NA DNU sidebar-a */}
  <div className="sidebar-footer">
    <img src={nexusLogo} alt="Above" className="above-footer" />
    <img src={logo} alt="Footer" className="footer-img" />
  </div>
</div>

{/* Overlay za mobile */}
<div className={`sidebar-overlay ${isOpen ? 'show' : ''}`} onClick={closeSidebar}></div>

    </>
  );
}

export default Sidebar;
